import PropTypes from 'prop-types';
import ReactLoader from 'react-loader-spinner';

const Loader = ({ children, loading }) => {
	return loading ? <div className="data-table__empty data-loader">
		<ReactLoader
			className="loadingSpinner__position__center"
			data-testid="loadingSpinner__position__center"
			type="ThreeDots"
			color="grey"
			height={10}
			width={15}
		/>
	</div > : <>
		{children}
	</>
}

Loader.propTypes = {
	children: PropTypes.node,
	loading: PropTypes.bool
}

export default Loader;
